import { useEffect } from 'react'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { useIntentionMarkAsSharedMutation } from '@/src/features/intention/services/useIntentionMarkAsSharedMutation'

type TUseMarkIntentionAsSharedProps = {
  isIntentionShared?: boolean
  intentionId: number
}

export const useMarkIntentionAsShared = ({ isIntentionShared, intentionId }: TUseMarkIntentionAsSharedProps) => {
  const { data: me } = useMeQuery()
  const { mutate: markAsShared, isPending, isError } = useIntentionMarkAsSharedMutation(intentionId)

  const isMyIntention = me?.intention?.id === intentionId
  const isAlreadyShared = isIntentionShared === true

  useEffect(() => {
    if (isMyIntention || isAlreadyShared || isPending || isError) return

    markAsShared()
  }, [isMyIntention, isAlreadyShared, isPending, isError, markAsShared])
}
